import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { URL } from "../../routers/constants";
import { connect } from "react-redux";
import IcPostComment from "../../assets/icon/svg/home/IcPostComment";
import IcLiveStream from "../../assets/icon/svg/home/IcLiveStream";
import IcCart from "../../assets/icon/svg/home/IcCart";

const Home = (props) => {
   const { user } = props;
   const navigate = useNavigate();
   useEffect(() => {
      // navigate(URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL)
   }, [])
   return (
      <div id="bot-scene-container" className="">
         <div id="bot-scene-content" className="scroll-light">
            <div className="app-v3-home">
               <div className="app-v3-home--container">
                  <div class="app-v3-home--reports">
                  </div>
                  <div className="app-v3-home--contents-container">
                     <div className="app-v3-home--main-contents-container">
                        <div className="app-v3-home--main-contents-title" title={`Xin chào, ${user.username}`}>
                           Xin chào, {user.username}
                        </div>
                        <div className="app-collapse app-collapse app-v3-home--contents--collapse-component pdt-0 new-features bd-0">
                           <div className="app-collapse-item app-collapse-item-active">
                              <div className="app-collapse-header" role="button" tabindex="0" aria-expanded="true">
                                 <div className="svg-next-icon app-collapse-arrow ic-collapse-16-16">
                                 </div>
                                 <div className="app-v3-home--contents--collapse-component--header">
                                    <div className="collapse-header--icon">
                                       <div className="svg-next-icon icon-hot">
                                       </div>
                                    </div>
                                    <div className="collapse-header--content">
                                       <span className="collapse-header--title" title="Tính năng mới">Tính năng mới</span>
                                       <span className="collapse-header--subTitle" title="Các tính năng nổi bật mới ra mắt">Các tính năng nổi bật mới ra mắt</span>
                                    </div>
                                 </div>
                              </div>
                              <div className="app-collapse-content app-collapse-content-active" >
                                 <div className="app-collapse-content-box">
                                    <div className="list-features--container">
                                       <a href="https://support.viettelmedia.vn/articles/61" className="item-feature--wrapper" target="_blank">
                                          <div className="item-feature--thumb">
                                             <IcLiveStream />
                                          </div>
                                          <div className="item-feature--content">
                                             <div className="item-feature--title">Livestream</div>
                                             <div className="item-feature--sub-title">
                                                Chuyển đổi thành đơn hàng ngay cả trước, trong và sau khi Livestream
                                             </div>
                                          </div>
                                       </a>
                                       <a
                                          href="https://support.viettelmedia.vn/articles/64"
                                          className="item-feature--wrapper" target="_blank">
                                          <div className="item-feature--thumb">
                                             <IcPostComment />
                                          </div>
                                          <div className="item-feature--content">
                                             <div className="item-feature--title">Tin bán hàng</div>
                                             <div className="item-feature--sub-title">Tăng trưởng doanh thu bán hàng, tự động chốt
                                                đơn theo mã sản phẩm</div>
                                          </div>
                                       </a>
                                       <a
                                          href="https://support.viettelmedia.vn/articles/67"
                                          className="item-feature--wrapper" target="_blank">
                                          <div className="item-feature--thumb">
                                             <IcCart />
                                          </div>
                                          <div className="item-feature--content">
                                             <div className="item-feature--title">Giỏ hàng</div>
                                             <div className="item-feature--sub-title">Quản lý và theo dõi mua sắm của khách hàng,
                                                tăng cơ hội chuyển đổi doanh thu</div>
                                          </div>
                                       </a></div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { user } = state;
   return {
      user
   };
};

export default connect(mapStateToProps, {})(Home);